import { useState } from 'react';
import { ref, get } from 'firebase/database';
import { database } from '../firebase/config';

export function useFirebaseData() {

  const [dipendenti, setDipendenti] = useState([]);
  const [veicoli, setVeicoli] = useState([]);
  const [cantieri, setCantieri] = useState([]);
  const [clienti, setClienti] = useState([]);

  async function caricaDipendenti() {
    const snapshot = await get(ref(database, 'dipendenti'));
    if (snapshot.exists()) {
      setDipendenti(Object.keys(snapshot.val()).map(key => ({ id: key, ...snapshot.val()[key] })));
    } else {
      setDipendenti([]);
    }
  }

  async function caricaVeicoli() {
    const snapshot = await get(ref(database, 'veicoli'));
    if (snapshot.exists()) {
      setVeicoli(Object.keys(snapshot.val()).map(key => ({ id: key, ...snapshot.val()[key] })));
    } else {
      setVeicoli([]);
    }
  }

  async function caricaCantieri() {
    const snapshot = await get(ref(database, 'cantieri'));
    if (snapshot.exists()) {
      setCantieri(Object.keys(snapshot.val()).map(key => ({ id: key, ...snapshot.val()[key] })));
    } else {
      setCantieri([]);
    }
  }

  async function caricaClienti() {
    const snapshot = await get(ref(database, 'clienti'));
    if (snapshot.exists()) {
      setClienti(Object.keys(snapshot.val()).map(key => ({ id: key, ...snapshot.val()[key] })));
    } else {
      setClienti([]);
    }
  }

  return {
    dipendenti, setDipendenti,
    veicoli, setVeicoli,
    cantieri, setCantieri,
    clienti, setClienti,
    caricaDipendenti,
    caricaVeicoli,
    caricaCantieri,
    caricaClienti,
  };
}
